/**
 * Product Recommendations
 * This component is used on the PDP pages to display recommended products fetched from Shopify's API.
 * @extends HTMLElement
 */
 class ProductRecommendations extends HTMLElement {

  /** Instantiate a ProductRecommendations Element */
  constructor() {

    /**
     * Inherit HTMLElement methods
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/super
     */
    super();

    /**
     * An intersection observer is required for this async component to properly work in the Shopify Editor
     * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
     */
    new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }

  /**
   * Handler for Intersection Observer
   * @param {Array} entries An array of IntersectionObserverEntry objects, each representing one threshold which was crossed, either becoming more or less visible than the percentage specified by that threshold.
   * @param {Object} observer The IntersectionObserver for which this callback is being invoked.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry
   * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
   */
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadRecommendations();
  }

  /**
   * Loads product recommendations from Shopify, these must be loaded from an API call.
   * @see https://shopify.dev/api/liquid/objects/recommendations
   */
  loadRecommendations() {
    // Check if the product recommendations URL is present in the data-url attribute
    if(this.dataset.url !== undefined && this.dataset.url.length) {
      fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
    }
  }

}
customElements.define('product-recommendations', ProductRecommendations);
